import React from "react";

import CommonStyle from "common/styles/common.css";
import Style from "common/styles/tree-selector-v2.css";
import YbSearch from "common/components/yb-search";
import YbTooltip from "common/components/yb-tooltip";

// V2:
// 1. Remove onKeyDown
// 2. change check all position

class YbTreeSelectorV2 extends React.Component {
  constructor(props) {
    super(props);

    var levels = this.props.items || [];
    var value = this.props.value;

    this.state = {
      drillTo: null,
      levels: levels,
      selected: value || [],
      searchText: levels.map((item) => ""),
    };

    if (levels.length < value.length) {
      this.state.drillTo = value[levels.length];
    }
  }

  handleClick(item, level, event) {
    if (!item.isCompatible && !item.hasChildren) {
      return;
    }
    var selected = this.state.selected;
    var levels = this.state.levels;
    var searchText = this.state.searchText;
    var selectedItems = this.getSelectedItems();
    var idProp = this.props.id || "id";

    while (selected.length && selected.length > level) {
      selected.pop();
    }

    while (levels.length && levels.length > level + 1) {
      levels.pop();
      searchText.pop();
    }

    selected.push(item);

    if (!item.hasChildren) {
      if (
        !selectedItems.find(
          (selectedItem) => item[idProp] === selectedItem[idProp]
        )
      ) {
        this.props.onSelect(item);
      } else {
        this.props.onRemove(item);
      }

      this.setState({
        selected: selected,
        levels: levels,
      });
    } else {
      this.setState({
        selected: selected,
        levels: levels,
        drillTo: item,
      });
    }

    if (event) {
      event.preventDefault();
    }
  }

  renderItems(items) {
    var levels = this.state.levels;
    var searchText = this.state.searchText;

    setTimeout(() => {
      levels.push(items);
      searchText.push("");
      this.setState({
        levels: levels,
        drillTo: null,
      });
    });

    return <span></span>;
  }

  searchTextChange(level, text) {
    var searchText = this.state.searchText;
    searchText[level] = text;

    this.setState({
      searchText: searchText,
    });
  }

  getSelectedItems() {
    var selectedItems = this.props.selectedItems;

    if (Array.isArray(selectedItems)) {
      return selectedItems;
    }

    if (selectedItems) {
      return [selectedItems];
    }

    return [];
  }

  isSelected(item) {
    var selectedItems = this.getSelectedItems();
    var idProp = this.props.id;

    if (!item.hasChildren) {
      return selectedItems.find(
        (selectedItem) => selectedItem[idProp] === item[idProp]
      );
    }
  }

  isAllSelected(level) {
    var selectedItems = this.getSelectedItems();
    var levels = this.state.levels;
    var idProp = this.props.id;

    return !levels[level]
      .filter(
        (item) => !item.hasChildren && item.isCompatible && !item.isOnboarded
      )
      .find(
        (item) =>
          !selectedItems.find(
            (selectedItem) => selectedItem[idProp] === item[idProp]
          )
      );
  }

  toggleAll(level) {
    var selectedItems = this.getSelectedItems();
    var levels = this.state.levels;
    var idProp = this.props.id;

    if (this.isAllSelected(level)) {
      this.props.onRemove(
        levels[level].filter(
          (item) => !item.hasChildren && item.isCompatible && !item.isOnboarded
        )
      );
    } else {
      this.props.onSelect(
        levels[level].filter(
          (item) =>
            !item.hasChildren &&
            item.isCompatible &&
            !item.isOnboarded &&
            !selectedItems.find(
              (selectedItem) => selectedItem[idProp] === item[idProp]
            )
        )
      );
    }
  }

  render() {
    var columns =
      this.props.columns ||
      this.state.levels.length + (this.state.drillTo ? 1 : 0);
    var size = Math.floor(12 / columns);
    var selected = this.state.selected;
    var idProp = this.props.id || "id";
    var invalid = this.props.invalid;
    var noHeader = this.props.noHeader;
    var short = this.props.short;
    // var noSort = this.props.noSort;
    var searchText = this.state.searchText;
    var selectedItems = this.getSelectedItems();

    return (
      <div
        className={`${CommonStyle.table} ${Style.treeSelector} ${
          invalid ? Style.invalid : ""
        }`}
      >
        <div
          className={`row ${CommonStyle.tableRowNoHover} ${
            Style["columns" + columns]
          }`}
        >
          {this.state.levels.concat(this.state.drillTo).map((items, level) => {
            var regexp = null;

            if (level < this.state.levels.length) {
              if (!items.length) {
                return (
                  <a
                    key={level}
                    className={`col-md-${size} ${Style.tableColumn} ${CommonStyle.accesibleItem}`}
                    disabled
                  >
                    <div
                      className={`row ${Style.node} ${Style.leaf} ${Style.noItems}`}
                    >
                      <div
                        className="col-md-12"
                        style={{ textAlign: "center" }}
                      >
                        No active units
                      </div>
                    </div>
                  </a>
                );
              }

              regexp = new RegExp(searchText[level], "i");

              return (
                <a
                  key={level}
                  className={`col-md-${size} ${Style.tableColumn} ${CommonStyle.accesibleItem}`}
                >
                  {!noHeader && (
                    <div className={`${Style.columnHeader}`}>
                      <span className={Style.checkAllWrapper}>
                        <YbTooltip
                          message={i18n`SELECT_ALL_ITEMS_IN_THIS_LEVEL`}
                          position="top"
                        >
                          <button
                            type="button"
                            className={CommonStyle.button}
                            onClick={this.toggleAll.bind(this, level)}
                          >
                            <i
                              className={`fa ${
                                this.isAllSelected(level)
                                  ? "fa-check-square-o"
                                  : "fa-square-o"
                              }`}
                            ></i>
                          </button>
                        </YbTooltip>
                      </span>

                      <span className={Style.seachInputWrapper}>
                        <YbSearch
                          value={searchText[level]}
                          type="text"
                          placeholder={i18n`SEARCH_BY_NAME_ELLIPSIS`}
                          onChange={this.searchTextChange.bind(this, level)}
                        />
                      </span>
                    </div>
                  )}
                  <div
                    className={`${Style.itemList} ${
                      short ? Style.itemListShort : ""
                    }`}
                  >
                    {items
                      .filter((item) => {
                        var isSelected =
                          selected[level] &&
                          selected[level][idProp] === item[idProp];

                        return isSelected || item.name.match(regexp);
                      })
                      .map((item, index) => {
                        var isOpened =
                          selected[level] &&
                          selected[level][idProp] === item[idProp]
                            ? Style.opened
                            : "";
                        var isSelected = false;

                        if (!item.hasChildren) {
                          isOpened = false;
                          isSelected = !!selectedItems.find(
                            (selectedItem) =>
                              item[idProp] === selectedItem[idProp]
                          )
                            ? Style.selected
                            : "";
                        }

                        if (item.isOnboarded && !item.hasChildren) {
                          return (
                            <div
                              key={`${level}-${index}`}
                              className={Style.nodeOnboarded}
                            >
                              {this.props.renderItemComponent(item, isSelected)}
                            </div>
                          );
                        }

                        if (!item.isCompatible && !item.hasChildren) {
                          return (
                            <div
                              key={`${level}-${index}`}
                              className={Style.nodeNotCompatible}
                            >
                              {this.props.renderItemComponent(item, isSelected)}
                            </div>
                          );
                        }

                        return (
                          <div
                            key={`${level}-${index}`}
                            onClick={this.handleClick.bind(this, item, level)}
                            className={`${isOpened} ${Style.node}`}
                          >
                            {this.props.renderItemComponent(item, isSelected)}
                          </div>
                        );
                      })}
                  </div>
                </a>
              );
            }

            if (items) {
              return (
                <div key={level} className={`col-md-${size}`}>
                  {this.props.children({
                    renderItems: this.renderItems.bind(this),
                    drillTo: this.state.drillTo,
                  })}
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    );
  }
}

module.exports = YbTreeSelectorV2;
